import { Component, OnInit } from '@angular/core';
import { OrganizationService } from './organization.service';
import * as _ from 'lodash';
import { SharedService } from '../services/shared.service';
import { S3Service } from '../services/s3.service';
import { Router } from '@angular/router';
import { TeamService } from '../team-selection/team.service';

@Component({
  selector: 'app-organizations',
  templateUrl: './organizations.component.html',
  styleUrls: ['./organizations.component.scss']
})
export class OrganizationsComponent implements OnInit {

  organizations: Array<any> = [];
  filteredOrganizations: Array<any> = [];
  userPriveleges: object = {};

  constructor(
    private _organizationService: OrganizationService,
    private _sharedService: SharedService,
    private _s3Service: S3Service,
    private _router: Router,
    private _teamService: TeamService
  ) { 
    this._sharedService.searchChange.subscribe((value) => {
      this.onSearch(value);
    })
  }

  ngOnInit(): void {
    let promises = [this._sharedService.getPrivileges(localStorage.getItem("role")).toPromise(), this._organizationService.getAllOrganizations().toPromise()]

    Promise.all(promises)
      .then((result: any) => {
        if (result[0]['success']) {
          this.userPriveleges = result[0]['data'][0]['privileges'];
        }
        if (result[1]['success']) {
          this.organizations = result[1]['data'];
          this.organizations = _.orderBy(this.organizations, [org => org.name.toLowerCase()], ['asc']);
          this.filteredOrganizations = this.organizations;
          _.forEach(this.organizations, (org) => {
            if (org.logo) {
              this.fetchFileFromS3(org);
            }
          })
        }
      })
  }

  checkPrivilege(accessType) {
    if(_.isEmpty(this.userPriveleges)) {
      return false;
    }
    return this._sharedService.checkPrivilege(this.userPriveleges, accessType);
  }

  fetchFileFromS3(organization: any) {
    // this.isLoading = true;
    if (organization.logo && organization.logo.length > 0) {
      this._s3Service.getObjectFromKey(organization.logo).subscribe((response) => {
        if (response && Object.keys(response["data"]).length > 0) {
          var binary = '';
          var bytes = new Uint16Array(response['data']);
          var len = bytes.byteLength;
          for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          let logo = window.btoa(binary);
          organization.profileImage = "data:image/jpeg;base64," + logo;
        }
      }, (error) => {
        console.log(error);
      });
    }
  }

  onClickingOrganizations(organization: any) {
    // localStorage.setItem("organizationName", organization.name);
    // localStorage.setItem("organizationCode", organization.code);
    // localStorage.setItem("organizationAddress", organization?.account_details?.address || "");
    // localStorage.setItem("organization", organization._id);
    // localStorage.setItem("organizationLogo", organization.logo);

    const url = this._router.serializeUrl(this._router.createUrlTree([localStorage.getItem('organizationCode') + '/org-forms/' + organization._id]));
    window.open(url, "blank");
  }


  onSearch(value: string) {
    this.filteredOrganizations = _.filter(this.organizations, (org) => {
      if(org.name.toLowerCase().includes(value.toLowerCase())) {
        return true;
      }
    })
  }

}
